import { Opportunity } from '../general';

export function patchOpportunity(item: Opportunity): void {
    if (item.percentToTarget != null) {
        /** item.percentToTarget = item.percentToTarget < 0 ? 0 : item.percentToTarget > 999 ? 999 : item.percentToTarget; */
        item.percentToTarget = Math.min(Math.max(item.percentToTarget, 0), 999);
    }

    if (item.percentToGoal != null) {
        /** item.percentToGoal = item.percentToGoal < 0 ? 0 : item.percentToGoal > 999 ? 999 : item.percentToGoal; */
        item.percentToGoal = Math.min(Math.max(item.percentToGoal, 0), 999);
    }
}
